import { FilterNotificationRequestModel } from './filte-notification-request-model';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
@Injectable({ providedIn: 'root' })
export class NotificationLogDataService {

    constructor(
        private dataProvider: DataService
    ) { }

    getNotificationTypes(): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetNotificationTypes).toPromise();
    }

    getNotificaionFilter(filterNotification: FilterNotificationRequestModel): Promise<GenericResponse<any>> {
        return this.dataProvider.GetAllwithHeaders<GenericResponse<any>>(Urls.GetFilteredNotifications, filterNotification).toPromise();
    }

    markNotificationAsReadbyId(model: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.ReadNotificationById, model).toPromise();
    }
    sentShareboxInformation(dealerId:string,appointmentId:number,languageCode:string,customerNo: string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.SentSarboxInformation,dealerId,appointmentId,languageCode,customerNo).toPromise();
    }
}